import React from 'react'

import { IInputBaseProps } from '../InputBase'
import { InputBaseStyled } from './styles'

interface IInputNumber extends IInputBaseProps {
  withoutNumberStyle?: boolean;
}

const InputNumber: React.FC<IInputNumber> = ({ withoutNumberStyle = false, ...rest }) => {
  return (
    <InputBaseStyled $withoutNumberStyle={withoutNumberStyle} {...rest} type="number" />
  )
}

export default InputNumber
